<template>
  <div>
    <a-popover
      v-model="visible"
      trigger="click"
      placement="bottomRight"
      overlayClassName="menu-user-avatar-pop"
      :autoAdjustOverflow="true"
      :arrowPointAtCenter="true"
    >
      <template slot="content">
        <a-spin :spinning="loading">
          <div class="app-info-menu">
            <div class="cursor-pointer app-info-menu-item" @click="openChangePwd">
              <div class="menu-label">
                <span class="label-text">修改密码</span>
              </div>
            </div>
            <div class="cursor-pointer app-info-menu-item" @click="handleLogout">
              <div class="menu-label">
                <span class="label-text">退出登录</span>
              </div>
            </div>
            <!-- <div class="app-info-menu-item">
            <div class="menu-label">
              <a-icon type="calendar"></a-icon>
              <span class="label-text">使用周期</span>
            </div>
            <div class="menu-content">1年零3个月</div>
          </div> -->
            <!-- <div class="app-info-menu-item">
            <div class="menu-label">
              <a-icon type="clock-circle"></a-icon>
              <span class="label-text">登陆时间</span>
            </div>
            <div class="menu-content">{{ $moment().format('YYYY.MM.DD HH:mm:ss') }}</div>
          </div> -->
          </div>
        </a-spin>
      </template>
      <div @click="openAppInfo" class="avatar" ref="avatarWrapper">
        <a-avatar :src="avatar">{{ nickname }}</a-avatar>
      </div>
    </a-popover>
    <a-modal v-model="modal.visible" title="修改密码" okText="确认修改" @ok="handleOk">
      <a-form labelAlign="left" class="flex-form form-label-5" :form="modal.form">
        <a-form-item label="旧密码">
          <a-input-password v-decorator="['oldPassword', { rules: [{ required: true, message: '请输入新密码' }]},]" placeholder="请输入新密码" />
        </a-form-item>
        <a-form-item label="新密码">
          <a-input-password
            v-decorator="[
              'password',
              {
                rules: [{ required: true, message: '请输入新密码' }],
              }
            ]" placeholder="请输入新密码" />
        </a-form-item>
        <a-form-item label="确认密码">
          <a-input-password v-decorator="[
            'confirmPassword',
            {
              validateFirst: true,
              validateTrigger: 'blur',
              rules: [{ required: true, message: '请输入确认密码' }, { validator: validateEqual }],
            },
          ]" placeholder="请输入新密码" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { toolMixin } from '@/utils/mixin'
export default {
  name: 'HeaderNotice',
  data() {
    return {
      loading: false,
      visible: false,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
      },
    }
  },
  mixins: [toolMixin],
  computed: {
    ...mapGetters(['avatar', 'nickname']),
  },
  methods: {
    ...mapActions(['Logout']),
    openAppInfo() {
      // if (!this.visible) {
      //   this.loading = true
      //   setTimeout(() => {
      //     this.loading = false
      //   }, 2000)
      // } else {
      //   this.loading = false
      // }
      this.visible = !this.visible
    },
    openChangePwd() {
      this.visible = false
      this.resetModal$t()
      this.modal.visible = true
    },

    handleLogout() {
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: () => {
          this.$store.commit('RESET_PERMISSION')
          return this.Logout({ type: 'reLaunch' }).catch(err => {
            this.$message.error({
              title: '错误',
              description: err.message,
            })
          })
        },
        onCancel() {},
      })
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            await this.$axios.post('/user/admin/user/resetPwd', {
              password: params.password,
              oldPassword: params.oldPassword
            })
            this.$message.success('操作成功!')
            this.Logout({ type: 'reLaunch' }).catch(err => {
              this.$message.error({
                title: '错误',
                description: err.message,
              })
            })
            this.modal.visible = false
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    validateEqual(rule, value, callback) {
      const password = this.modal.form.getFieldValue('password')
      if (value === password) {
        callback()
      } else {
        callback(new Error('两次输入密码不一致'))
      }
    },
  },
}
</script>

<style lang="css">
.menu-user-avatar-pop {
  box-shadow: 0px 5px 10px 0px rgba(153, 153, 153, 0.5);
  width: 95px;
  padding-top: 0;
  border-radius: 10px;
}
</style>
<style lang="less" scoped>
.app-info-menu {
  margin: -8px 0;
  .app-info-menu-item {
    height: 42px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f4f4f4;
    &:last-child {
      border-bottom: 0;
    }
    .menu-label {
      color: #333;
      display: flex;
      .anticon {
        color: @primary-color;
        margin-right: 13px;
        font-size: 18px;
      }
      align-items: center;
    }
    .menu-content {
      color: #999;
    }
  }
}
.avatar {
  display: flex;
  line-height: 32px;
}
</style>
